import React from 'react';
import { CheckCircle2, ExternalLink, Sparkles } from 'lucide-react';

interface ImportCompleteProps {
  siteId: string | null;
  pageCount: number;
  onAnotherImport: () => void;
  onClose: () => void;
}

export const ImportComplete: React.FC<ImportCompleteProps> = ({
  siteId,
  pageCount,
  onAnotherImport,
  onClose,
}) => {
  return (
    <div className="flex flex-col h-full bg-slate-900 text-white">
      <div className="px-6 py-4 border-b border-slate-800">
        <div className="flex items-center gap-2 text-green-400 mb-1">
          <CheckCircle2 className="w-4 h-4" />
          <span className="text-xs font-semibold uppercase tracking-wider">Done</span>
        </div>
        <h2 className="text-lg font-semibold">Your site is ready</h2>
        <p className="text-sm text-slate-400 mt-1">
          Imported {pageCount} page{pageCount === 1 ? '' : 's'} from the source.
        </p>
      </div>

      <div className="flex-1 px-6 py-6 flex flex-col items-center justify-center text-center">
        <Sparkles className="w-12 h-12 text-orange-400 mb-3" />
        <p className="text-slate-300 max-w-sm">
          Open the site in the editor to refine copy, swap images, or publish. Everything came from
          your source — re-import any time to refresh.
        </p>
      </div>

      <div className="px-6 py-3 border-t border-slate-800 flex flex-wrap gap-2 justify-end">
        <button
          onClick={onAnotherImport}
          className="px-3 py-2 text-sm text-slate-400 hover:text-white"
        >
          Import another
        </button>
        {siteId && (
          <a
            href={`/sites/${siteId}`}
            onClick={onClose}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-orange-500 hover:bg-orange-400 text-white font-semibold"
          >
            Open in editor
            <ExternalLink size={14} />
          </a>
        )}
      </div>
    </div>
  );
};
